import React, { useState } from 'react';
import BentoCard from '../components/BentoCard';
import logo from '../images/logo.jpg'; 
import determinationLetter from '../images/PositiveSomebody501c.pdf';

const AboutUs = () => {
  // State for Board Grid Flipping
  const [flippedIndex, setFlippedIndex] = useState(null);
  
  // State for Director Card Flipping
  const [isDirectorFlipped, setIsDirectorFlipped] = useState(false);

  const handleCardClick = (index) => {
    setFlippedIndex(flippedIndex === index ? null : index);
  };

  // 1. THE DIRECTOR
  const director = { 
    name: "Jenny Metzmaker", 
    role: "Founder & CEO", 
    employment: "MSU Federal Credit Union",
    bio: "Her desire to be a Positive Mental Health Advocate comes from being an abuse and suicide survivor. She leads with passion, creating art and spending time with her loved ones to recharge. Favorite Quote: “Just keep swimming” - Dory", 
    copingSkill: "Creating art & family time" 
  };

  // 2. THE BOARD
  const boardMembers = [
    { 
      name: "Maggie Garza", 
      role: "President", 
      employment: "AVP of Operations at Jackson National",
      bio: "Maggie is married and has three boys. When she’s not working, she’s playing sports (softball, bowling) with her husband or friends. She loves Steelers football and traveling! Giving back to the community is important to her family. Favorite Quote: 'Difficult roads often lead to beautiful destinations.' - Zig Ziglar", 
      copingSkill: "Playing sports & traveling" 
    },
    { 
      name: "Dakota Anderson-White", 
      role: "Board Secretary", 
      employment: "Operations Associate at Jackson National",
      bio: "He enjoys time with friends and family. Favorite Quote: “Never Forget What You Are. The Rest Of World Will Not. Wear It Like Armor, And It Can Never Hurt You.” - Tyrion Lannister", 
      copingSkill: "Time with friends & family" 
    },
    { 
      name: "Tristen Dodge", 
      role: "Secretary", 
      employment: "", 
      bio: `A proud Michigander, wife, and mother of three grown children, Tristen works at Voya Financial. She finds peace in her garden and holds a deep love for animals. Committed to making a positive impact, Tristen finds joy in volunteering and lending a helping hand to make the world a little brighter.`, 
      copingSkill: "Gardening & time with animals" 
    },
    {
      name: "Susan Isham",
      role: "Treasurer",
      employment: "",
      bio: "", // Minimal info
      copingSkill: "" // No flip
    },
    { 
      name: "Sheila Nash", 
      role: "Member at Large", 
      employment: "Special Educator K-12",
      bio: "Sheila has been an educator for over 30 years and a coach for academic and sports teams. She currently teaches and coaches in Lansing, MI. Much to her husband's dismay, she has no plans to retire anytime soon.", 
      copingSkill: "Coaching & volunteering" 
    },
    { 
      name: "Jamie Otter", 
      role: "Member at Large", 
      employment: "School Social Worker for the Saginaw ISD",
      bio: "Jamie serves as a School Social Worker for the Saginaw ISD. When she isn't working, she loves spending quality time with family, friends, and her dogs. Her creative and relaxing hobbies include nature photography, sewing, and reading.", 
      copingSkill: "Nature photography & sewing" 
    },
    { 
      name: "Victoria Hay", 
      role: "Member at Large", 
      employment: "Social Work Graduate",
      bio: "Victoria is a master's-level graduate in social work from Michigan State University. She has worked for CEI Community Mental Health on their Assertive Community Treatment team, and she currently works at Cognitive Consultants. She works with children and adults on substance use, depression, anxiety, and trauma. She works in the areas of trauma and PTSD and is EMDR trained.", 
      copingSkill: "Grounding exercises & journaling" 
    },
    { 
      name: "Bronwynn Kewin", 
      role: "Member at Large", 
      employment: "BHS/DBT Skills Coach",
      bio: "Bronwynn is dedicated to fostering safe, open environments for mental health conversations, believing that everyone deserves to build a life worth living. Outside of her advocacy work, she enjoys spending time with loved ones and listening to music like Fleetwood Mac. Favorite Quote: \"Once we learn that thoughts are just thoughts, they have a lot less power over us.\" - Debbie Corso", 
      copingSkill: "Listening to Fleetwood Mac" 
    },
    { 
      name: "Marisa Townsend", 
      role: "Member at Large", 
      employment: "SFC, AZ Army National Guard",
      bio: "Based in Phoenix, Arizona, Marisa serves as a Sergeant First Class in the Arizona Army National Guard with over 15 years of service. A passionate sexual assault victim advocate, she holds a Bachelor's degree in Forensic Psychology from Arizona State University. Marisa is deeply committed to empowering youth, serving as a mentor for foster children through Arizonians for Children.", 
      copingSkill: "Mentoring foster youth" 
    },
     { 
      name: "Jenifer Hamilton", 
      role: "Member at Large", 
      employment: "Healthcare Executive",
      bio: "Jenifer Hamilton, MSN, RN, CHPN is a healthcare executive certified in hospice and palliative nursing. Her expertise in holistic care at end of life aligns with Positive Somebody's mission of providing mental health tools to handle whatever life brings.", 
      copingSkill: "Holistic care practices" 
    },
    // --- NEW MEMBERS BELOW ---
    {
      name: "Jack Johnson",
      role: "Member at Large",
      employment: "Retired Educator",
      bio: "Retired East Lansing Middle School English Teacher. Baseball coach, dedicated father, and grandfather.",
      copingSkill: "" // No flip
    },
    {
      name: "Victoria Key-Walker",
      role: "Member at Large",
      employment: "Center for Social Justice",
      bio: "Juvenile Re-Entry Supervisor / JJDPA Compliance Monitor (MI).",
      copingSkill: "" // No flip
    }
  ];

  return (
    <main className="max-w-7xl mx-auto p-4 lg:p-8 space-y-12">
      
      {/* CSS Override */}
      <style>{`
        @media (hover: hover) {
          /* Only allow hover flip if the card has the 'flippable' class */
          .group.flippable:hover .flip-card-inner {
            transform: rotateY(180deg);
          }
        }
        .bio-scroll::-webkit-scrollbar {
          width: 4px;
        }
        .bio-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .bio-scroll::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.1);
          border-radius: 20px;
        }
      `}</style>

      {/* SECTION 1: MISSION HERO */}
      <div className="text-center max-w-4xl mx-auto py-12">
        <h1 className="text-4xl md:text-6xl font-heading font-bold text-primary-navy mb-6">
          Be a Positive Somebody
        </h1>
        <p className="text-lg md:text-xl text-gray-600 leading-relaxed font-body">
          We focus on giving kids and families the confidence to recognize their emotions, the skills to navigate them, and the support to know they’re not alone.
        </p>
      </div>

      {/* SECTION 2: LEADERSHIP */}
      <div className="mb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* LEFT COLUMN */}
            <div className="text-center lg:text-left space-y-6">
                <div>
                    <h2 className="text-3xl font-heading font-bold text-primary-navy border-b-4 border-accent-orange inline-block pb-2">
                    Leadership
                    </h2>
                </div>
                <h3 className="text-4xl md:text-5xl font-heading font-black text-primary-navy">
                    Meet Our Founder
                </h3>
                <p className="text-xl text-gray-600 font-medium max-w-md mx-auto lg:mx-0 leading-relaxed">
                    Leading with passion, resilience, and a commitment to mental health advocacy.
                </p>
                <div className="hidden lg:block bg-orange-50 p-6 rounded-2xl border-l-8 border-accent-orange mt-8 max-w-sm">
                    <p className="text-lg font-bold text-primary-navy italic">
                        “Just keep swimming”
                    </p>
                    <p className="text-sm font-bold text-gray-400 mt-2">— Dory</p>
                </div>
            </div>

            {/* RIGHT COLUMN: The Director Card */}
            <div className="flex justify-center lg:justify-start w-full">
                <div 
                    className="group flippable w-full max-w-md h-[550px] [perspective:1000px] cursor-pointer"
                    onClick={() => setIsDirectorFlipped(!isDirectorFlipped)}
                >
                    <div 
                        className="flip-card-inner relative w-full h-full text-center transition-all duration-700 [transform-style:preserve-3d]"
                        style={{ 
                            transform: isDirectorFlipped ? 'rotateY(180deg)' : undefined 
                        }}
                    >
                        {/* FRONT */}
                        <BentoCard 
                            enableHover={false}
                            position="absolute"
                            className="inset-0 flex flex-col items-center justify-center border-t-8 border-accent-orange shadow-xl [backface-visibility:hidden]"
                        >
                            <div className="w-32 h-32 rounded-full overflow-hidden mb-6 border-4 border-accent-orange shadow-md shrink-0">
                                <img src={logo} alt={director.name} className="w-full h-full object-cover" />
                            </div>
                            <h3 className="text-3xl font-heading font-bold text-primary-navy leading-tight mb-1">{director.name}</h3>
                            <p className="text-accent-orange font-bold text-lg uppercase tracking-wide mb-4">{director.role}</p>
                            <p className="text-xs font-bold text-gray-400 mb-4 italic px-4 border-b border-gray-100 pb-2 w-full max-w-xs">
                                {director.employment}
                            </p>
                            <div className="flex-grow w-full px-6 overflow-y-auto bio-scroll">
                                <p className="text-gray-600 text-base leading-relaxed font-medium">
                                    {director.bio}
                                </p>
                            </div>
                            <p className="mt-4 text-xs text-gray-400 font-bold animate-bounce uppercase tracking-widest shrink-0">
                                Tap to Flip
                            </p>
                        </BentoCard>

                        {/* BACK */}
                        <BentoCard 
                            enableHover={false}
                            position="absolute"
                            color="bg-primary-navy"
                            className="inset-0 text-white flex flex-col items-center justify-center bg-pattern-dots [backface-visibility:hidden] [transform:rotateY(180deg)]"
                        >
                            <span className="text-7xl mb-6">🎨</span>
                            <h4 className="text-2xl font-bold text-accent-yellow mb-4">My Coping Skill</h4>
                            <p className="text-xl font-body px-8 font-bold">{director.copingSkill}</p>
                        </BentoCard>
                    </div>
                </div>
            </div>

        </div>
      </div>

      {/* SECTION 3: BOARD OF DIRECTORS */}
      <div>
        <h2 className="text-3xl font-heading font-bold text-primary-navy mb-8 border-b-4 border-accent-yellow inline-block pb-2">
          Meet Our Board
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {boardMembers.map((member, index) => {
            // Check if this member has a coping skill to flip to
            const canFlip = member.copingSkill && member.copingSkill.length > 0;

            return (
                <div 
                    key={index} 
                    // Add 'flippable' class only if they have data
                    className={`group ${canFlip ? 'flippable cursor-pointer' : 'cursor-default'} h-[520px] [perspective:1000px]`} 
                    onClick={() => canFlip && handleCardClick(index)}
                >
                <div 
                    className="flip-card-inner relative w-full h-full text-center transition-all duration-700 [transform-style:preserve-3d]"
                    style={{ 
                        transform: flippedIndex === index && canFlip ? 'rotateY(180deg)' : undefined 
                    }}
                >
                    {/* FRONT (Board) */}
                    <BentoCard 
                    enableHover={false}
                    position="absolute"
                    className="inset-0 flex flex-col items-center justify-center border-t-8 border-primary-forest [backface-visibility:hidden]"
                    >
                    <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border-4 border-gray-100 shadow-sm shrink-0">
                        <img src={logo} alt={member.name} className="w-full h-full object-cover" />
                    </div>
                    
                    <h3 className="text-xl font-heading font-bold text-primary-navy leading-tight mb-1">{member.name}</h3>
                    <p className="text-accent-orange font-bold text-xs uppercase tracking-wide mb-2">{member.role}</p>
                    
                    {member.employment && (
                        <p className="text-xs font-bold text-gray-400 mb-3 italic px-4 border-b border-gray-100 pb-2 w-full shrink-0">
                            {member.employment}
                        </p>
                    )}

                    {member.bio && (
                        <div className="flex-grow w-full px-4 overflow-y-auto bio-scroll">
                            <p className="text-gray-600 text-sm leading-snug">
                                {member.bio}
                            </p>
                        </div>
                    )}
                    
                    {/* Only show 'Tap to Flip' if they can actually flip */}
                    {canFlip && (
                        <p className="mt-4 text-[10px] text-gray-400 font-bold animate-bounce uppercase tracking-widest shrink-0">
                            Tap to Flip
                        </p>
                    )}
                    </BentoCard>

                    {/* BACK (Board) - Only rendered if there is data, though hidden via CSS if no flip */}
                    {canFlip && (
                        <BentoCard 
                        enableHover={false}
                        position="absolute"
                        color="bg-primary-navy"
                        className="inset-0 text-white flex flex-col items-center justify-center bg-pattern-dots [backface-visibility:hidden] [transform:rotateY(180deg)]"
                        >
                        <span className="text-6xl mb-4">✨</span>
                        <h4 className="text-xl font-bold text-accent-yellow mb-2">My Coping Skill</h4>
                        <p className="text-lg font-body px-6">{member.copingSkill}</p>
                        </BentoCard>
                    )}
                </div>
                </div>
            );
          })}
        </div>
      </div>

      {/* SECTION 4: TRANSPARENCY LINKS */}
      <BentoCard className="bg-gray-100 flex flex-col md:flex-row items-center justify-between p-8">
        <div className="mb-4 md:mb-0">
          <h3 className="text-xl font-bold text-primary-navy mb-1">Commitment to Transparency</h3>
          <p className="text-gray-600 mb-2">View our 501(c)(3) status and documentation.</p>
          <div className="inline-block bg-white px-3 py-1 rounded border border-gray-200">
             <p className="text-sm font-mono font-bold text-gray-500">EIN: 84-4387253</p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
            <a 
                href={determinationLetter}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2 border-2 border-primary-navy text-primary-navy rounded-full font-bold hover:bg-primary-navy hover:text-white transition-colors w-full sm:w-auto text-center flex items-center justify-center gap-2"
            >
                <span>📄</span> IRS Determination Letter
            </a>
        </div>
      </BentoCard>

    </main>
  );
};

export default AboutUs;